import { atom, useAtom } from 'jotai'

const homeScreenRefetchTriggerAtom = atom(false)

export const useHomeScreenRefetch = () => {
  const [, setRefetchTrigger] = useAtom(homeScreenRefetchTriggerAtom)
  const triggerRefetch = () => {
    setRefetchTrigger(prev => !prev)
  }
  return {
    triggerRefetch
  }
}

export const useHomeScreenRefetchTrigger = () => {
  const [refetchTrigger] = useAtom(homeScreenRefetchTriggerAtom)
  return refetchTrigger
}
